import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import SalesPage from "./pages/SalesPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/workshop" element={<SalesPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
